export default "__VITE_ASSET__7pYZpqq1__"